// Identyfikatory elementów pytania: treść pytania nazywa grupę ocen albo pole tekstowe (aria-labelledby),
// opis je opisuje (aria-describedby). Ten sam przedrostek trafia do bloku pytania.
const questionIds = (questionId) => {
  const prefix = `pytanie-${questionId}`

  return {
    block: prefix,
    caption: `${prefix}-tresc`,
    description: `${prefix}-opis`,
    input: `${prefix}-pole`,
    error: `${prefix}-blad`,
    // Identyfikator, który TextField z MUI 4 nadaje tekstowi pomocniczemu pola (`${id}-helper-text`).
    hint: `${prefix}-pole-helper-text`,
    saved: `${prefix}-zapisano`,
  }
}

export default questionIds
